const styles = (theme) => ({
    container: {
        width: '100%',
        height: '100%',
        minHeight: '570px',
        overflow: 'hidden',
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    boxLogin: {
        maxWidth: '420px',
        boxShadow: '0px 15px 45px rgba(0, 0, 0, .2)',
        borderRadius: '30px',
    },
    content: {
        zIndex: 998,
        position: 'relative',
        padding: '1em',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    backButton: {
        color: '#3372b8',
        position: 'absolute',
        top: 0,
        left: 0,
        padding: '5px',
        fontSize: '1rem',
        marginTop: '.5em',
    },
    logo: {
        width: '15em',
    },
    swipeViews: {
        maxWidth: 290,
    },
    item: {
        textAlign: 'center',
    },
    register: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontSize: '.9rem',
        margin: '.5em 0 1em',
        alignSelf: 'flex-end',
    },
    forgotPassword: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
        fontSize: '.9rem',
        margin: '.5em 1em 1em',
        display: 'block',
        float: 'right',
    },
    right: {
        float: 'right',
    },
    textBlue: {
        color: '#3372b8',
    },
    subtitle: {
        flex: 1,
        fontSize: '1rem',
        margin: '0',
        padding: '0',
    },
    observation: {
        flex: 1,
        fontSize: '.9rem',
    },
    boxTextField: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: '0px !important',
    },
    boxRecoveryInfo: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '0px !important',
        textAlign: 'center',
    },
    icone: {
        margin: '20px 10px 0 0',
    },
    box: {
        display: 'block',
        paddingLeft: '50px',
        flex: 1,
    },
    btnEsqueciSenha: {},
    loginButton: {
        width: '50%',
        textTransform: 'uppercase',
        color: 'white',
        borderRadius: '20px',
        boxShadow: '0 5px 10px rgba(0,0,0,.4)',
        backgroundColor: '#4ba4c4',
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    iconSend: {
        marginLeft: '10px',
    },
});

export default styles;
